import {
  FETCH_KPI_ACTIVITIES,
  GET_COMPETITION_BADGES,
  GET_COMPETITION_WIN_CONDITIONS,
  GET_COMPETITION_TYPES,
  ADD_COMPETITION,
  GET_CAMPAIGNS,
  GET_INPUT_KPI_USERS,
  GET_COMPETITIONS,
  DELETE_COMPETITION,
  GET_COMPETITION,
  UPDATE_COMPETITION,
  COMPETITION_ASSIGN_USERS,
  END_COMPETITION,
  GET_COMPETITIONS_WIDGET_DATA,
  GET_USER_COMPETITION_BY_STATUS,
  ACTIVATE_COMPETITION,
  GET_COMPETITION_USER_LIST,
  JOIN_COMPETITION,
  RE_RUN_COMPETITION,
  REMOVE_COMPETITION_FROM_FAVORITES,
} from "lib/constants";
import { deleteAPICall, getAPICall, postAPICall, putAPICall } from "../lib/callApi";

export const fetchKPIActivities = async () => {
  const data = await getAPICall(FETCH_KPI_ACTIVITIES, true);
  return data;
};

export const fetchBadges = async () => {
  const data = await getAPICall(GET_COMPETITION_BADGES, true);
  return data;
};

export const fetchCampaigns = async () => {
  const data = await getAPICall(GET_CAMPAIGNS, true);
  return data;
};

export const fetchWinConditions = async () => {
  const data = await getAPICall(GET_COMPETITION_WIN_CONDITIONS, true);
  return data;
};

export const fetchCompetitionTypes = async () => {
  const data = await getAPICall(GET_COMPETITION_TYPES, true);
  return data;
};

export const addCompetition = async (payload) => {
  const data = await postAPICall(ADD_COMPETITION, true, payload);
  return data;
};

export const fetchUsers = async () => {
  const data = await getAPICall(GET_INPUT_KPI_USERS, true);
  return data;
};

export const fetchCompetitions = async (payload) => {
  const data = await getAPICall(GET_COMPETITIONS, true, payload);
  return data;
};

export const deleteCompetition = async (id, params) => {
  const data = await deleteAPICall(DELETE_COMPETITION + id, true, params);
  return data;
};

export const fetchCompetition = async (id) => {
  const data = await getAPICall(GET_COMPETITION + id, true);
  return data;
};

export const updateCompetition = async (id, payload) => {
  const data = await putAPICall(UPDATE_COMPETITION + id, true, payload);
  return data;
};

export const assignUsers = async (payload) => {
  const data = await postAPICall(COMPETITION_ASSIGN_USERS, true, payload);
  return data;
};

export const endCompetition = async (payload) => {
  const data = await postAPICall(END_COMPETITION, true, payload);
  return data;
};

export const fetchWidgetsData = async (payload) => {
  const data = await getAPICall(GET_COMPETITIONS_WIDGET_DATA, true, payload);
  return data;
};

export const fetchCompetitionByStatus = async (payload) => {
  const data = await getAPICall(GET_USER_COMPETITION_BY_STATUS, true, payload);
  return data;
};

export const competitionActivate = async (payload) => {
  const data = await postAPICall(ACTIVATE_COMPETITION, true, payload);
  return data;
};

export const getCompetitionsUsersList = async (payload) => {
  const data = await getAPICall(GET_COMPETITION_USER_LIST, true, payload);
  return data;
};

export const joinCompetition = async (payload) => {
  const data = await postAPICall(JOIN_COMPETITION, true, payload);
  return data;
};

export const reRunCompetition = async (payload) => {
  const data = await postAPICall(RE_RUN_COMPETITION, true, payload);
  return data;
};

export const removeFromFavorites = async (id) => {
  const data = await deleteAPICall(REMOVE_COMPETITION_FROM_FAVORITES + id, true);
  return data;
};
